<script>
  import { onMount } from "svelte";
  import { getBenefits } from "../../helper/GetHelper";
  import BenefitEdit from "../../edit/Benefit_Edit.svelte";
  import BuyerPersonaEdit from "../../edit/BuyerPersona_Edit.svelte";
  import { Modal } from "../../components/display";
  import { Button, Card, Input } from "../../components/ui";
  import { benefitEdit, personaDataEdit, pjgSave, pjgAdd } from "../../helper/PostHelper";

  export let currentRoute;

  let activeBenefitIndex = 0;
  let editBenefit = false;
  let editPersona = false;
  let newGain = null;
  let newPain = null;
  let model = null;
  let staticData = null;
  const productId = currentRoute.namedParams.id; //productId
  const personaId = currentRoute.namedParams.buyerPersonaId; //productId

  getBenefits(productId, personaId).then(data => {
    console.log(data);
    model = data.model;
    staticData = data.staticData;
  });

  const cancel = function() {
    editBenefit = false;
    editPersona = false;

  };
  const benefitSave = async function() {
    editBenefit = false;
    const index = activeBenefitIndex;
    const rVal = await benefitEdit(productId, personaId, model[index]);
    //model[index].data = rVal;
  };

    const personaSave = async function() {
    editPersona = false;
    personaDataEdit(productId, personaId, staticData.buyerPersona);
    // const rVal = await benefitEdit(productId, personaId, model[index]);
    //model[index].data = rVal;
  };

  const newBenefit = async function(type, text){
   if(staticData.buyerPersona.pjg[type] == null)
    return;

   const newItem = await pjgAdd(productId, personaId, type, text, staticData.buyerPersona.pjg[type].items.length);
    staticData.buyerPersona.pjg[type].items = [...staticData.buyerPersona.pjg[type].items, newItem];
    newGain = null;
    newPain = null;
  }

  const addNew = function(index) {
    let newItem = {
      text: null,
      sortPos: model.benefits.items.length,
      value: `benefit_${benefitVal}`,
      basedOn: null
    };
    model.benefits.items = [...model.benefits.items, newItem];
    activeBenefitIndex = newItem.sortPos;
    showEdit = true;
    benefitVal++;
  };

  const pjgNew = async function(type, text){
   if(staticData.buyerPersona.pjg[type] == null)
    return;

   const newItem = await pjgAdd(productId, personaId, type, text, staticData.buyerPersona.pjg[type].items.length);
    staticData.buyerPersona.pjg[type].items = [...staticData.buyerPersona.pjg[type].items, newItem];
    newGain = null;
    newPain = null;
  }
</script>

{#if staticData != null}

  <Card>
    <div class="flex flex-row p-4" on:click={()=>{editPersona = true}}>
      <div class="w-1/4">IMAGE</div>
      <div class="ml-2">
      <h2>Buyer Persona Name</h2>
      <p>{staticData.buyerPersona.age}, {staticData.buyerPersona.gender}, {staticData.buyerPersona.familyStatus}, {staticData.buyerPersona.children} kids, {staticData.buyerPersona.incomeRange} income</p>
      <p>{staticData.buyerPersona.education}</p>
      </div>
    </div>
  </Card>
  <div class="my-6 p-4">
    <h2 class="text-2xl">Pains</h2>
    <ul>
      {#each staticData.buyerPersona.pjg.pains.items as pain}
        <li class="flex flex-row">
        <Input class="w-1/6" bind:model={pain.text} />
        <Button on:submit={()=>{pjgSave(productId, personaId, pain)}}>Save pain</Button>
        </li>
      {/each}
         <li class="flex flex-row">
          <Input class="w-1/6" bind:model={newPain} />
          <Button on:submit={()=>{pjgNew('pains', newPain)}}>Add new gain</Button>
        </li>
    </ul>
  </div>

  <div class="my-6 p-4">
    <h2 class="text-2xl">Gains</h2>
    <ul>
      {#each staticData.buyerPersona.pjg.gains.items as gain}
          <li class="flex flex-row">
        <Input class="w-1/6"  bind:model={gain.text} />
        <Button on:submit={()=>{pjgSave(productId, personaId,gain)}}>Save gain</Button>
        </li>
      {/each}
         <li class="flex flex-row">
          <Input class="w-1/6" bind:model={newGain} />
          <Button on:submit={()=>{pjgNew('gains', newGain)}}>Add new gain</Button>
        </li>
    </ul>
  </div>
{/if}


{#if model != null}
  {#each model as benefit, i (benefit.data.value)}
    <div
      class="border-main rounded border-4 p-4 mt-4"
      on:click={() => {
        activeBenefitIndex = i;
        editBenefit = true;
      }}>
      <p class="text-2xl">{benefit.data.text}</p>
      {#if benefit.data.basedOn != null}
        {#each benefit.data.basedOn.pains as pain (pain.text)}
          <div class="flex-row flex mt-2 mb-2">
            <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
              Pain
            </div>
            {pain.text}
          </div>
        {/each}
        {#each benefit.data.basedOn.gains as gain}
          <div class="flex-row flex mt-2 mb-2">
            <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
              Gain
            </div>
            {gain.text}
          </div>
        {/each}
        {#each benefit.data.basedOn.jobs as job}
          <div class="flex-row flex mt-2 mb-2">
            <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
              Job
            </div>
            {job.text}
          </div>
        {/each}
        {#each benefit.data.basedOn.features as feature}
          <div class="flex-row flex mt-2 mb-2">
            <div class="px-3 py-1 bg-gray-400 ml-2 mr-2 text-xs rounded">
              Feature
            </div>
            {feature.text}
          </div>
        {/each}
      {/if}
    </div>
  {/each}
{/if}

{#if editBenefit}
  <Modal>
    <div>
      <BenefitEdit
        bind:model={model[activeBenefitIndex].data}
        data={staticData}
        isEdit={true}
        on:save={() => {
          benefitSave();
        }}
        on:cancel={() => {
          cancel();
        }}
        index={2} />
    </div>
  </Modal>
{/if}

{#if editPersona}
  <Modal>
    <div class="p-4">
      <BuyerPersonaEdit
        bind:model={staticData.buyerPersona}
        isEdit={true}
        index={2} />
        <div class="mt-8"><Button primary={true} on:submit={()=>{ personaSave()}}>Save</Button>
        <Button on:submit={()=>{ cancel()}}>Cancel</Button></div>
        
    </div>
  </Modal>
{/if}